import { AxiosError } from 'axios';
import { useMutation } from 'react-query';

import axios from './axios';

export interface UseUpdateOrganizationInfoVariables {
  landingDescription: string | null;
  landingTitle: string;
  logo?: string | null;
}

export interface UseUpdateOrganizationInfoData {
  header: string;
  landing_description: string | null;
  landing_title: string;
  logo: string | null;
  title: string;
}

export function useUpdateOrganizationInfo() {
  return useMutation<
    UseUpdateOrganizationInfoData,
    AxiosError<UseUpdateOrganizationInfoData>,
    UseUpdateOrganizationInfoVariables
  >((variables) => {
    const data = {
      landing_description: variables.landingDescription,
      landing_title: variables.landingTitle,
      temporary_logo: variables.logo,
    };

    return axios
      .put<UseUpdateOrganizationInfoData>(
        '/posht/picasso/organization/info/',
        data,
      )
      .then((res) => res.data);
  });
}
